import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { TypeDechetDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-type-dechet-select',
  templateUrl: './type-dechet-select.component.html',
  styleUrls: ['./type-dechet-select.component.css']
})
export class TypeDechetSelectComponent implements OnInit, OnDestroy {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
  @Select(ControlPanelStore.typesDechets$) typesDechets$: Observable<TypeDechetDto[]>;

  @Input() titleNull: string;

  @Input() width: number;
  @Input() widthPopUp: number = 250;
  @Input() height: number = 50;
  @Input() disabled: boolean = false;
  @Input() onlyActifs: boolean = false;
  private _typeDechetId: number = null
  @Input()
  get typeDechetId() {
    return this._typeDechetId;
  }
  set typeDechetId(val) {
    this._typeDechetId = val;
    this.getTypeDechetInComponent();
  }

  @Input() typesDechetsInput = null;

  @Input() showImage: boolean = false;
  @Output() typeDechetIdChange = new EventEmitter<number>();

  @Input() cell: any;

  InitId = null;

  TypesDechets: TypeDechetDto[] = [];
  SelectedTypeDechet: TypeDechetDto = null;
  ColumnName = [];

  td: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
    // Instanciate Globalize for DevExtreme components
    this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());

    this.translate.get(
      [
        'Designation'
      ]
    ).subscribe(translations => {
      this.ColumnName.push(translations.Designation);
    });
  }

  ngOnInit() {
    if (this.typeDechetId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.typeDechetId));
    }

    this.td = this.typesDechets$.subscribe(res => {
      if (res != null) {
        this.TypesDechets = this.typesDechetsInput != null ? [] : res;
        if (this.onlyActifs) {
          this.TypesDechets = this.TypesDechets.filter(value => value.EstActif);
        }
        this.SelectedTypeDechet = this.TypesDechets.find(td => td.Id == this.typeDechetId);
        if (this.titleNull && !this.TypesDechets.find(p => p.Id == 0))
        {
          this.TypesDechets.unshift({ Id: 0, Identifiant: this.titleNull, Designation: this.titleNull });
        }
      }
    });

    if(this.typesDechetsInput != null) {
      this.typesDechetsInput.subscribe(res => {
        this.TypesDechets = res;
      });
    }
  }

  ngOnDestroy() {
    this.td?.unsubscribe();
  }

  getTypeDechetInComponent() {
    this.SelectedTypeDechet = this.TypesDechets.find(td => td.Id == this.typeDechetId);
  }

  updateInfo(event) {
    this.typeDechetId = event.currentSelectedRowKeys.length === 1 ? event.currentSelectedRowKeys[0].Id : this.typeDechetId;
    if (!!this.cell && this.InitId !== this.typeDechetId) {
      this.cell.setValue(this.typeDechetId);
    }
    this.SelectedTypeDechet = event.currentSelectedRowKeys.length == 1 ? event.currentSelectedRowKeys[0] : this.SelectedTypeDechet;
    this.typeDechetIdChange.emit(this.typeDechetId);

    if(this.typeDechetId != null) {
      this.dropDown.instance.close();
    }
  }

  getHeight() {
    return { 'height': this.height+'px' };
  }

  getHeightImage() {
    return this.height;
  }

  onOpened() {
    if(this.typeDechetId == null) {
      this.dataGrid.instance.clearSelection();
    }

    document.body.childNodes.forEach(element => {
      if(element.nodeType == 1) {
        if((element as HTMLElement).className.includes("dx-dropdowneditor-overlay")) {
          (element.childNodes[0] as HTMLElement).style.width = `${this.widthPopUp}px`;
        }
      }
    });
  }
}
